import { Component, Input } from '@angular/core';
import { TagModule } from 'primeng/tag';
import { NgClass } from '@angular/common';
import { BaseComponent } from '@app/shared/base-component';

@Component({
  selector: 'app-loyalty-category',
  standalone: true,
  imports: [TagModule, NgClass],
  templateUrl: './loyalty-category.component.html',
  styleUrl: './loyalty-category.component.scss',
})
export class LoyaltyCategoryComponent extends BaseComponent {
  @Input() status: string | undefined;
  @Input() colorCode!: string | undefined;
  @Input() statusCode!: any;
@Input() bgColor!: string | undefined;
  get statusClass(): string {
    switch (this.statusCode) {
      case 'Classic':
        return 'classic';
      case 'Silver':
        return 'silver';
      case 'Gold':
        return 'gold';
      case 1:
        return 'gold';
      case 2:
        return 'silver';

      case 5:
        return 'rejected';
      case 123010003:
        return 'under-review';
      default:
        return 'gold';
    }
  }

  protected override translatedContent(): void {}
}
